import React from 'react';
import HelpApiLayout from '../../../../components/layout/HelpApiLayout';
import HelpSidebar from '../../../../components/layout/HelpSidebar';
import SimpleCard from '../../components/SimpleCard';
import LastUpdated from '../../../../components/layout/docs/LastUpdated';
import { getHelpArticleRoute } from '../../../../constants/routes';
import { getHelpRoute } from '../../../../utils/navigation';
import '../../HelpCenter.css';

/**
 * Integrations Category Page
 */
const Integrations = () => {
  const cards = [
    {
      title: 'Phantom Connect',
      description: 'Use your Google or Apple account to instantly create or access your crypto wallet within the app.',
      route: getHelpRoute(getHelpArticleRoute('integrations', 'integration-1'))
    }
  ];

  return (
    <HelpApiLayout type="help" sidebar={<HelpSidebar />}>
      <div className="help-center">
        <div className="help-center-container">
          <header className="lp-section-header">
            <h1 className="lp-section-title">Integrations</h1>
            <p className="lp-section-subtitle">
              Connect with partner apps to split your payments instantly.
            </p>
          </header>

          <section className="help-center-categories">
            <div className="help-center-cards">
              {cards.map((card, index) => (
                <SimpleCard
                  key={index}
                  title={card.title}
                  description={card.description}
                  route={card.route}
                />
              ))}
            </div>
          </section>

          <LastUpdated />
        </div>
      </div>
    </HelpApiLayout>
  );
};

export default Integrations;
